/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}
export default function EyeSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 2C3.6896 2 0 6.57371 0 8C0 9.49314 2.8368 14 8 14C13.1632 14 16 9.49314 16 8C16 6.57371 12.3104 2 8 2ZM8 10.5714C7.52532 10.5714 7.06131 10.4206 6.66663 10.1381C6.27195 9.85551 5.96434 9.45391 5.78269 8.98404C5.60104 8.51418 5.55351 7.99715 5.64612 7.49834C5.73872 6.99953 5.9673 6.54135 6.30294 6.18173C6.63859 5.8221 7.06623 5.5772 7.53178 5.47798C7.99734 5.37876 8.4799 5.42968 8.91844 5.62431C9.35698 5.81893 9.73181 6.14852 9.99553 6.57139C10.2592 6.99426 10.4 7.49142 10.4 8C10.4 8.68199 10.1471 9.33604 9.69706 9.81827C9.24697 10.3005 8.63652 10.5714 8 10.5714Z" fill="currentColor" />
        </svg>
    );
}
